import { Locale } from "../Interfaces/locale";

export const localeTld: Record<Locale, string> = {
    'NZ': '.co.nz',
    'AU': '.com.au',
    'UK': '.co.uk',
    'US': '.com',
}